
import {
    ApiCall
} from './index';

export const CHECKLISTS = (id) => "/checklists?site_id="+id;
export const POST_CHECKLIST = "/checklists";
export const GET_FORM = (id) => `/checklists/${id}`;
export const COMPLETED_CHECKLISTS = (id, query) => query? `/checklists/${id}/completed${query}`: `/checklists/${id}/completed`;

export const getChecklists = async(data) => {
    return await ApiCall('GET', CHECKLISTS(data.id), null);
};

export const postForm = async(data) => {
    return await ApiCall('POST', POST_CHECKLIST, data);
};

export const getForm = async(data) => {
    return await ApiCall('GET', GET_FORM(data.id), null, false);
};

export const getCompletedChecklists = async(data) => {
    return await ApiCall('GET', COMPLETED_CHECKLISTS(data.id, data.query), null);
};



// WEBPACK FOOTER //
// ./src/services/checklist.js